import React, { useEffect } from "react";
import { Wrench, Clock } from "lucide-react";
import { useAuth } from "../lib/auth";
import ideathonMark from "../assets/ideathon-mark.png";

export default function MaintenancePage({ message, until }) {
  const { loadConfig } = useAuth();

  // Auto-poll so the page flips back to the live site on its own once maintenance ends.
  useEffect(() => {
    const id = setInterval(() => { loadConfig(); }, 60000);
    return () => clearInterval(id);
  }, [loadConfig]);

  let eta = "";
  if (until) {
    try {
      const d = new Date(until);
      if (!isNaN(d)) eta = d.toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" });
    } catch { /* ignore bad date */ }
  }

  return (
    <div className="min-h-screen bg-[#0A0F1E] text-white flex items-center justify-center px-5" data-testid="maintenance-page">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_0%,rgba(255,106,0,0.12),transparent_55%)] pointer-events-none" aria-hidden />
      <div className="relative max-w-lg text-center">
        <div className="flex items-center justify-center gap-2.5 mb-8">
          <img src={ideathonMark} alt="NoobSync Innovate logo" className="h-8 w-auto shrink-0" width="30" height="32" />
          <div className="flex items-baseline gap-1">
            <span className="font-display text-xl tracking-tighter text-white">NoobSync</span>
            <span className="font-display text-xl tracking-tighter text-brand">Innovate</span>
          </div>
        </div>
        <div className="inline-flex items-center justify-center w-16 h-16 border border-brand/30 bg-brand/5 mb-8">
          <Wrench className="w-7 h-7 text-brand" strokeWidth={1.5} />
        </div>
        <div className="label-eyebrow text-brand mb-3">Scheduled maintenance</div>
        <h1 className="font-display text-4xl sm:text-5xl leading-none">
          We&apos;ll be right back.
        </h1>
        <p className="text-gray-400 mt-5 leading-relaxed">
          {message || "IdeaThon is undergoing a quick tune-up. Please check back shortly — your registration, team and submissions are safe."}
        </p>
        {eta && (
          <div className="mt-6 inline-flex items-center gap-2 text-sm text-gray-300 border border-white/10 bg-white/5 px-4 py-2" data-testid="maintenance-eta">
            <Clock className="w-4 h-4 text-brand" /> Expected back by <span className="text-white font-medium">{eta}</span>
          </div>
        )}
        <p className="text-xs text-gray-600 mt-8">Thanks for your patience — NoobSync Innovations</p>
      </div>
    </div>
  );
}
